import React, { useEffect, useState } from 'react';
import ComboEstados from './combo';


export const ComboEstadosContainer = (props: any) => {
  
  
  const getOptions = () =>{
    return [ { value: 1, inputDisplay: "Pendiente validación Responsable Área" }, 
    { value: 2, inputDisplay: "Pendiente validación Fiscal" }, { value: 3, inputDisplay: "Pendiente facturación" }, { value: 4, inputDisplay: "Facturado" },
    { value: 5, inputDisplay: "Fin Semana" },{ value: 6, inputDisplay: "Todo" }]
  }

  return <ComboEstados {...props} options={getOptions()}/>
};

export default ComboEstadosContainer;